import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { Portal } from 'react-native-paper'
import { Modalize } from 'react-native-modalize'
import { useTheme } from '../../../theming/ThemeProvider'

const FiltersModal = forwardRef(({ children, isDesktop }, ref) => {
  const { theme } = useTheme()
  return (
    isDesktop ? <>{children}</> : (
      <Portal>
        <Modalize
          ref={ref}
          adjustToContentHeight
          handlePosition='inside'
          modalStyle={{
            backgroundColor: theme.CARD_BACKGROUND
          }}
        >
          {children}
        </Modalize>
      </Portal>)
  )
})

FiltersModal.propTypes = {
  children: PropTypes.node.isRequired,
  isDesktop: PropTypes.bool
}

export default FiltersModal
